import { useState } from 'react'
import { Button } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { primary_color } from '../../../Helper/uiHelper'
import { getCookie } from '../../../Helper/cookieHelper'
import { removeNullValues } from '../../../helper'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { getPayloadToLoadGridData } from '../../../CMSComponent/Grid/Component/MainGrid/gridHelper'

/**
 * School Years → Codes: queue 2-sheet Excel export into Downloads (same as CMS export).
 * Uses the same filter stack as connect-template grid load so Export matches searched rows.
 */
const ExportYearCodesButton = ({ gridRelatedData, disabled }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const globalSearchValue = useSelector((state) => state.Page.globalSearchValue)
  const savedFilters = useSelector((state) => state.CMS.savedFilters)

  const buildPayload = () => {
    const yearId = currentRow?.[currentRow?.length - 1]?.id
    const tableName = gridRelatedData?.tableGrid?.name
    const contentName = gridRelatedData?.content?.name
    const loadPayload = getPayloadToLoadGridData(
      {
        ...gridRelatedData,
        savedFilters: savedFilters || gridRelatedData?.savedFilters,
      },
      () => {}
    )
    const advanced = gridRelatedData?.gridAdvancedFilter?.[contentName]

    const payload = removeNullValues({
      ...loadPayload,
      ...(tableName && savedFilters?.[tableName] ? savedFilters[tableName] : {}),
      ...(gridRelatedData?.initialPayload || {}),
      ...(gridRelatedData?.gridFilters || {}),
      parent_table_row_id: yearId,
      item_date_time_id: yearId,
      page_name: gridRelatedData?.pageName || 'codes_items',
      template_name: gridRelatedData?.page_data?.template_name || 'locker_years',
      grid_id: gridRelatedData?.mainGrid?.id,
      cms_key:
        gridRelatedData?.currentTabData?.cms_tab_key ||
        gridRelatedData?.mainGrid?.cms_tab_key ||
        gridRelatedData?.page_data?.cms_header_name ||
        gridRelatedData?.page_data?.cms_header_key,
      ...(advanced?.length
        ? {
            '-grid_advance_filter': advanced
              .map((item) => {
                const fields = item?.fields?.filter((field) => field.value)
                return fields?.length ? { ...item, fields } : null
              })
              .filter(Boolean),
          }
        : {}),
      ...(globalSearchValue ? { '-global-search': globalSearchValue } : {}),
    })

    // Export all matching rows — never page/selection-limit the download
    delete payload.rec_per_page
    delete payload.page
    delete payload.ids
    delete payload.main
    if (Array.isArray(payload['-grid_advance_filter']) && payload['-grid_advance_filter'].length === 0) {
      delete payload['-grid_advance_filter']
    }

    return payload
  }

  const run = () => {
    const yearId = currentRow?.[currentRow?.length - 1]?.id
    if (!yearId) {
      dispatch(setNotification({ type: 'error', message: 'Open a school year first' }))
      return
    }

    setLoading(true)
    const token = getCookie('AUTH_TOKEN')
    fetch(`${process.env.REACT_APP_API_URL}/automatic-codes/export-year-codes`, {
      method: 'POST',
      headers: {
        authorization: token && token !== 'undefined' ? `Bearer ${token}` : 'Bearer token',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(buildPayload()),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}))
        if (!response.ok || data?.success === false) {
          throw new Error(data?.message || 'Export failed')
        }
        dispatch(
          setNotification({
            type: 'success',
            message: data?.message || 'Check download process in download section.',
          })
        )
        dispatch(fetchUpdateApiData(false))
      })
      .catch((err) => {
        dispatch(setNotification({ type: 'error', message: err?.message || 'Export failed' }))
      })
      .finally(() => setLoading(false))
  }

  return (
    <Button
      className='subtitle1 mb-2 mr-2'
      disabled={disabled || loading}
      style={{ background: primary_color, border: 'none' }}
      onClick={run}>
      {loading ? 'Queuing…' : 'Export Data'}
    </Button>
  )
}

export default ExportYearCodesButton
